import { render, staticRenderFns } from "./vehicleDetailsContent.vue?vue&type=template&id=0d4846ea&scoped=true"
import script from "./vehicleDetailsContent.vue?vue&type=script&lang=js"
export * from "./vehicleDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4846ea",
  null
  
)

export default component.exports